import StyledSelectDropdown from "../StyledSelectDropdown"
import { FormField, SectionHeader } from "./CreateJobFields"

type ManagementExperienceSectionProps = {
    isEditMode: boolean
    managementExperienceOptions: Array<{ id: string; name: string }>
    peopleManagedRangeOptions: Array<{ id: string; name: string }>
    managementExperienceValue: "YES" | "NO" | null
    peopleManagedRangeValue: string | null
    peopleManagedRangeLoading?: boolean
    onManagementExperienceChange: (value: string) => void
    onPeopleManagedRangeChange: (value: string) => void
}

export const ManagementExperienceSection = ({
    isEditMode,
    managementExperienceOptions,
    peopleManagedRangeOptions,
    managementExperienceValue,
    peopleManagedRangeValue,
    peopleManagedRangeLoading = false,
    onManagementExperienceChange,
    onPeopleManagedRangeChange,
}: ManagementExperienceSectionProps) => (
    <section className="mb-10">
        <SectionHeader title="Management Experience" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
            <FormField label="Management Experience Required" required>
                <StyledSelectDropdown
                    options={managementExperienceOptions}
                    value={managementExperienceValue || ""}
                    onChange={onManagementExperienceChange}
                    placeholder="Select YES/NO"
                    disabled={isEditMode}
                />
            </FormField>
            {managementExperienceValue === "YES" && (
                <FormField label="How many people did you manage?" required>
                    <StyledSelectDropdown
                        options={peopleManagedRangeOptions}
                        value={peopleManagedRangeValue || ""}
                        onChange={onPeopleManagedRangeChange}
                        placeholder="Select range"
                        disabled={isEditMode || peopleManagedRangeLoading}
                    />
                </FormField>
            )}
        </div>
    </section>
)
